import React from 'react'
import CyLogoImage from '../../assets/images/cy/cy-logo.png'
import './index.less'

const CyLogo: React.FC<{}> = () => {
  return (
    <div className='cy-logo'>
      {
        <a href='/'><img src={CyLogoImage} alt='LOGO' className='cy-logo__image' /></a>
      }
    </div>
  )
}

export default CyLogo
